/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
import { dataAxios, transactionsAxios, unicornAxios } from 'util/Api';
import {
  FETCH_MERCHANT_ACCOUNTS_INIT,
  FETCH_MERCHANT_ACCOUNTS_SUCCESS,
  FETCH_MERCHANT_ACCOUNTS_ERROR,
  FETCH_USER_MERCHANT_ACCOUNTS_INIT,
  FETCH_USER_MERCHANT_ACCOUNTS_SUCCESS,
  FETCH_USER_MERCHANT_ACCOUNTS_ERROR,
  UPDATE_MERCHANT_ACCOUNT_INIT,
  UPDATE_MERCHANT_ACCOUNT_SUCCESS,
  UPDATE_MERCHANT_ACCOUNT_ERROR,
  ADD_MERCHANT_ACCOUNT_INIT,
  ADD_MERCHANT_ACCOUNT_SUCCESS,
  ADD_MERCHANT_ACCOUNT_ERROR,
  FETCH_MERCHANT_BENEFICIARIES_INIT,
  FETCH_MERCHANT_BENEFICIARIES_SUCCESS,
  FETCH_MERCHANT_BENEFICIARIES_ERROR,
  CREATE_MERCHANT_BENEFICIARY_INIT,
  CREATE_MERCHANT_BENEFICIARY_SUCCESS,
  CREATE_MERCHANT_BENEFICIARY_ERROR,
  UPDATE_MERCHANT_BENEFICIARY_INIT,
  UPDATE_MERCHANT_BENEFICIARY_SUCCESS,
  UPDATE_MERCHANT_BENEFICIARY_ERROR,
  DELETE_MERCHANT_BENEFICIARY_INIT,
  DELETE_MERCHANT_BENEFICIARY_SUCCESS,
  DELETE_MERCHANT_BENEFICIARY_ERROR,
  SEARCH_MERCHANT_ACCOUNTS,
  SEARCH_PROCESSORS,
  SET_SELECTED_MERCHANT_ACCOUNT,
  FETCH_SELECTED_MERCHANT_ACCOUNT,
  SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  UPDATE_API_TOKEN_INIT,
  UPDATE_API_TOKEN_SUCCESS,
  UPDATE_API_TOKEN_ERROR,
  FETCH_API_TOKENS_INIT,
  FETCH_API_TOKENS_SUCCESS,
  FETCH_API_TOKENS_ERROR,
  FETCH_WALLETS_INIT,
  FETCH_WALLETS_SUCCESS,
  FETCH_WALLETS_ERROR,
  FETCH_WALLETS_AGG_BALANCE_INIT,
  FETCH_WALLETS_AGG_BALANCE_SUCCESS,
  FETCH_WALLETS_AGG_BALANCE_ERROR,
  FETCH_WALLETS_AGG_ROLLING_RESERVE_INIT,
  FETCH_WALLETS_AGG_ROLLING_RESERVE_SUCCESS,
  FETCH_WALLETS_AGG_ROLLING_RESERVE_ERROR,
  FETCH_WALLET_OVERVIEW_INIT,
  FETCH_WALLET_OVERVIEW_SUCCESS,
  FETCH_WALLET_OVERVIEW_ERROR,
  FETCH_WALLET_OVERVIEW_PER_PSP_INIT,
  FETCH_WALLET_OVERVIEW_PER_PSP_SUCCESS,
  FETCH_WALLET_OVERVIEW_PER_PSP_ERROR,
  CREATE_SETTLEMENT_REPORT_INIT,
  CREATE_SETTLEMENT_REPORT_SUCCESS,
  CREATE_SETTLEMENT_REPORT_ERROR,
  FETCH_SETTLEMENT_REPORT_INIT,
  FETCH_SETTLEMENT_REPORT_SUCCESS,
  FETCH_SETTLEMENT_REPORT_ERROR,
  DELETE_SETTLEMENT_REPORT_INIT,
  DELETE_SETTLEMENT_REPORT_SUCCESS,
  DELETE_SETTLEMENT_REPORT_ERROR,
  UPDATE_SETTLEMENT_REPORT_INIT,
  UPDATE_SETTLEMENT_REPORT_SUCCESS,
  UPDATE_SETTLEMENT_REPORT_ERROR,
  FETCH_SETTLEMENT_REPORT_SUMMARY_INIT,
  FETCH_SETTLEMENT_REPORT_SUMMARY_SUCCESS,
  FETCH_SETTLEMENT_REPORT_SUMMARY_ERROR,
  SET_ACTIVE_MERCHANT_ACCOUNT,
  GENERATE_API_KEY_INIT,
  GENERATE_API_KEY_SUCCESS,
  GENERATE_API_KEY_ERROR,
  UPDATE_API_KEY_INIT,
  UPDATE_API_KEY_SUCCESS,
  UPDATE_API_KEY_ERROR,
  DELETE_API_KEY_INIT,
  DELETE_API_KEY_SUCCESS,
  DELETE_API_KEY_ERROR,
  FETCH_API_KEYS_INIT,
  FETCH_API_KEYS_SUCCESS,
  FETCH_API_KEYS_ERROR,
  FETCH_AFFILIATE_MERCHANT_ACCOUNTS_INIT,
  FETCH_AFFILIATE_MERCHANT_ACCOUNTS_SUCCESS,
  FETCH_AFFILIATE_MERCHANT_ACCOUNTS_ERROR,
  DELETE_MERCHANT_ACCOUNT_INIT,
  DELETE_MERCHANT_ACCOUNT_ERROR,
  DELETE_MERCHANT_ACCOUNT_SUCCESS,
  FETCH_TRAFFIC_WEBSITES_START,
  FETCH_TRAFFIC_WEBSITES_ERROR,
  FETCH_TRAFFIC_WEBSITES_SUCCESS,
  ADD_TRAFFIC_WEBSITE_ERROR,
  ADD_TRAFFIC_WEBSITE_START,
  ADD_TRAFFIC_WEBSITE_SUCCESS,
  UPDATE_TRAFFIC_WEBSITE_START,
  UPDATE_TRAFFIC_WEBSITE_SUCCESS,
  UPDATE_TRAFFIC_WEBSITE_ERROR,
} from '../../constants/ActionTypes';

export const fetchMerchantAccounts = (params = '', search = false) => (dispatch) => {
  dispatch({ type: FETCH_MERCHANT_ACCOUNTS_INIT });
  dataAxios.get(`merchants/${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
    const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
    const data = {
      data: response.data, currentPage, totalItems, search,
    };
    dispatch({ type: FETCH_MERCHANT_ACCOUNTS_SUCCESS, payload: data });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_MERCHANT_ACCOUNTS_ERROR });
  });
};

export const fetchAffiliateMerchantAccounts = (params = '', search = false) => (dispatch) => {
  dispatch({ type: FETCH_AFFILIATE_MERCHANT_ACCOUNTS_INIT });
  dataAxios.get(`merchants/${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
    const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
    const data = { data: response.data, currentPage, totalItems };
    dispatch({ type: FETCH_AFFILIATE_MERCHANT_ACCOUNTS_SUCCESS, payload: data });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_AFFILIATE_MERCHANT_ACCOUNTS_ERROR });
  });
};

export const fetchUserMerchantAccounts = (userId, params = '') => (dispatch) => {
  dispatch({ type: FETCH_USER_MERCHANT_ACCOUNTS_INIT });
  dataAxios.get(`merchants/user/${userId}${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
    const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
    const data = { data: response.data, currentPage, totalItems };
    dispatch({ type: FETCH_USER_MERCHANT_ACCOUNTS_SUCCESS, payload: data });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_USER_MERCHANT_ACCOUNTS_ERROR });
  });
};

export const setSelectedMerchantAccount = (account) => (dispatch) => {
  dispatch({ type: SET_SELECTED_MERCHANT_ACCOUNT, payload: account });
};

export const addMerchantAccount = (merchantAccount) => (dispatch) => {
  dispatch({ type: ADD_MERCHANT_ACCOUNT_INIT });
  dataAxios.post('merchants/', merchantAccount).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    if (data && data.name !== 'MongoError') {
      dispatch({ type: ADD_MERCHANT_ACCOUNT_SUCCESS, payload: data });
      dispatch({ type: SHOW_MESSAGE, payload: `Added merchant account: ${data.name}` });
    } else {
      dispatch({ type: ADD_MERCHANT_ACCOUNT_ERROR });
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble adding merchant account" });
      console.error('Error: ', data);
    }
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: ADD_MERCHANT_ACCOUNT_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const updateMerchantAccount = (
  id, merchant, notify = true, isDetailedView = false,
) => (dispatch) => {
  dispatch({ type: UPDATE_MERCHANT_ACCOUNT_INIT });

  dataAxios.put(`merchants/${id}`, merchant).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    if (data && data._id) {
      dispatch({ type: UPDATE_MERCHANT_ACCOUNT_SUCCESS, payload: data });
      if (!isDetailedView) {
        dispatch(setSelectedMerchantAccount(data));
      }
    }

    if (notify) {
      const message = 'Successfully updated merchant account';
      dispatch({ type: SHOW_MESSAGE, payload: message });
    }
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: UPDATE_MERCHANT_ACCOUNT_ERROR });
  });
};

export const deleteMerchantAccount = (merchantId) => (dispatch) => {
  dispatch({ type: DELETE_MERCHANT_ACCOUNT_INIT });
  dataAxios.delete(`merchants/${merchantId}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: DELETE_MERCHANT_ACCOUNT_SUCCESS, payload: merchantId });
    dispatch({ type: SHOW_MESSAGE, payload: response.message });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble updating this" });
    }
    dispatch({ type: DELETE_MERCHANT_ACCOUNT_ERROR });
    console.error('Error: ', error.message);
  });
};

export const getMerchantById = (id) => (dispatch) => {
  dispatch({ type: FETCH_START });
  dispatch({ type: FETCH_SELECTED_MERCHANT_ACCOUNT });
  dataAxios.get(`merchants/${id}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    dispatch({ type: SET_SELECTED_MERCHANT_ACCOUNT, payload: data });
    dispatch({ type: FETCH_SUCCESS });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_ERROR });
    console.error(error);
  });
};

export const createMerchantBeneficiary = (values) => (dispatch) => {
  dispatch({ type: CREATE_MERCHANT_BENEFICIARY_INIT });
  dataAxios.post('merchantCharges/', values).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    dispatch({ type: CREATE_MERCHANT_BENEFICIARY_SUCCESS, payload: data });
    dispatch({ type: SHOW_MESSAGE, payload: 'Successfully created merchant charge' });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: 'Error while creating merchant charge' });
    }
    dispatch({ type: CREATE_MERCHANT_BENEFICIARY_ERROR });
    console.error(error);
  });
};

export const fetchMerchantBeneficiaries = (params = '') => (dispatch) => {
  dispatch({ type: FETCH_MERCHANT_BENEFICIARIES_INIT });
  dataAxios.get(`merchantCharges/${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
    const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
    const data = { data: response.data, currentPage, totalItems };
    dispatch({ type: FETCH_MERCHANT_BENEFICIARIES_SUCCESS, payload: data });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: 'Error while fetching merchant charges' });
    }
    dispatch({ type: FETCH_MERCHANT_BENEFICIARIES_ERROR });
    console.error(error);
  });
};

export const fetchMerchantBeneficiariesById = (merchantId, params = '') => (dispatch) => {
  dispatch({ type: FETCH_MERCHANT_BENEFICIARIES_INIT });
  dataAxios.get(`merchantCharges/merchant/${merchantId}/${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
    const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
    const data = { data: response.data, currentPage, totalItems };
    dispatch({ type: FETCH_MERCHANT_BENEFICIARIES_SUCCESS, payload: data });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: 'Error while fetching merchant charges' });
    }
    dispatch({ type: FETCH_MERCHANT_BENEFICIARIES_ERROR });
    console.error(error);
  });
};

export const updateMerchantBeneficiary = (id, values) => (dispatch) => {
  dispatch({ type: UPDATE_MERCHANT_BENEFICIARY_INIT });
  dataAxios.put(`merchantCharges/${id}`, values).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    dispatch({ type: UPDATE_MERCHANT_BENEFICIARY_SUCCESS, payload: data });
    dispatch({ type: SHOW_MESSAGE, payload: 'Successfully updated merchant charge' });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      const message = 'Error occurred while updating merchant charge';
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: message });
    }
    dispatch({ type: UPDATE_MERCHANT_BENEFICIARY_ERROR });
    console.error(error);
  });
};

export const deleteMerchantBeneficiary = (id) => (dispatch) => {
  dispatch({ type: DELETE_MERCHANT_BENEFICIARY_INIT });
  dataAxios.delete(`merchantCharges/${id}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: DELETE_MERCHANT_BENEFICIARY_SUCCESS, payload: { id } });
    dispatch({ type: SHOW_MESSAGE, payload: response.message });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      const message = 'Error while deleting merchant charge';
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: message });
    }
    dispatch({ type: DELETE_MERCHANT_BENEFICIARY_ERROR });
    console.error(error);
  });
};

export const searchMerchantAccounts = (params = '') => (dispatch) => {
  dispatch({ type: FETCH_START });
  dataAxios.get(`merchants/${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;

    dispatch({ type: SEARCH_MERCHANT_ACCOUNTS, payload: data });
    dispatch({ type: FETCH_SUCCESS });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_ERROR });
    console.error(error);
  });
};

export const searchProcessors = (params = '') => (dispatch) => {
  dispatch({ type: FETCH_START });
  dataAxios.get(`processors/${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;

    dispatch({ type: SEARCH_PROCESSORS, payload: data });
    dispatch({ type: FETCH_SUCCESS });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_ERROR });
    console.error(error);
  });
};

export const updateAPIToken = (merchantId, merchantData) => (dispatch) => {
  dispatch({ type: UPDATE_API_TOKEN_INIT });
  dataAxios.put(`merchantDtls/${merchantId}`, merchantData).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    dispatch({ type: UPDATE_API_TOKEN_SUCCESS, payload: data });
    dispatch({ type: SHOW_MESSAGE, payload: 'Successfully updated API Token' });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: UPDATE_API_TOKEN_ERROR });
  });
};

export const getAPITokensByMerchantId = (merchantId) => (dispatch) => {
  dispatch({ type: FETCH_API_TOKENS_INIT });
  dataAxios.get(`merchantDtls/merchant/${merchantId}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    dispatch({ type: FETCH_API_TOKENS_SUCCESS, payload: data });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_API_TOKENS_ERROR });
  });
};

export const getWalletsFilters = (filters) => (dispatch) => {
  dispatch({ type: FETCH_WALLETS_INIT });
  dataAxios.post('wallets/filters/', filters).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
    const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
    const data = { data: response.data, currentPage, totalItems };

    dispatch({ type: FETCH_WALLETS_SUCCESS, payload: data });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_WALLETS_ERROR });
  });
};

export const getWallets = (merchantId, params = '') => (dispatch) => {
  dispatch({ type: FETCH_WALLETS_INIT });
  dataAxios.get(`wallets/${merchantId}/${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
    const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
    const data = { data: response.data, currentPage, totalItems };

    dispatch({ type: FETCH_WALLETS_SUCCESS, payload: data });
    dispatch({ type: FETCH_SUCCESS });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_ERROR });
    console.error(error);
  });
};

export const getWalletsAggregatedBalance = (params = '') => (dispatch) => {
  dispatch({ type: FETCH_WALLETS_AGG_BALANCE_INIT });
  dataAxios.get('wallets/aggregated-balance').then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    dispatch({ type: FETCH_WALLETS_AGG_BALANCE_SUCCESS, payload: data });
    dispatch({ type: FETCH_SUCCESS });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_WALLETS_AGG_BALANCE_ERROR });
    console.error(error);
  });
};

export const getWalletsAggregatedRollingReserve = (params = '') => (dispatch) => {
  dispatch({ type: FETCH_WALLETS_AGG_ROLLING_RESERVE_INIT });
  transactionsAxios.get(`aggregated-rolling-reserve/0${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;

    dispatch({ type: FETCH_WALLETS_AGG_ROLLING_RESERVE_SUCCESS, payload: data });
    dispatch({ type: FETCH_SUCCESS });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_WALLETS_AGG_ROLLING_RESERVE_ERROR });
    console.error(error);
  });
};

export const fetchWalletOverview = (params = '', transactionType) => (dispatch) => {
  dispatch({ type: FETCH_WALLET_OVERVIEW_INIT });
  transactionsAxios.get(`aggregated/wallet/overview${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;

    dispatch({ type: FETCH_WALLET_OVERVIEW_SUCCESS, payload: data, transactionType });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message, transactionType });
    }
    dispatch({ type: FETCH_WALLET_OVERVIEW_ERROR });
    console.error(error);
  });
};

export const fetchWalletOverviewPerPSP = (params = '', transactionType) => (dispatch) => {
  dispatch({ type: FETCH_WALLET_OVERVIEW_PER_PSP_INIT });
  transactionsAxios.get(`aggregated/wallet/overviewGroupByProcessor${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse.data;
    const data = response?.data;

    dispatch({ type: FETCH_WALLET_OVERVIEW_PER_PSP_SUCCESS, payload: data, transactionType });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message, transactionType });
    }
    dispatch({ type: FETCH_WALLET_OVERVIEW_PER_PSP_ERROR });
    console.error(error);
  });
};

export const fetchSettlementReportSummary = (params = '') => (dispatch) => {
  dispatch({ type: FETCH_SETTLEMENT_REPORT_SUMMARY_INIT });
  dataAxios.get(`settlementReports/aggregateSettlements/amount${params ? `?${params}` : ''}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;


    dispatch({ type: FETCH_SETTLEMENT_REPORT_SUMMARY_SUCCESS, payload: data });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_SETTLEMENT_REPORT_SUMMARY_ERROR });
    console.error(error);
  });
};

export const createSettlementReport = (reportData) => (dispatch) => {
  dispatch({ type: CREATE_SETTLEMENT_REPORT_INIT });
  dataAxios.post('settlementReports/', reportData).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;

    dispatch({ type: CREATE_SETTLEMENT_REPORT_SUCCESS, payload: data });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: CREATE_SETTLEMENT_REPORT_ERROR });
  });
};

export const fetchSettlementReports = (params = '') => (dispatch) => {
  dispatch({ type: FETCH_SETTLEMENT_REPORT_INIT });
  dataAxios.get(`settlementReports/${params ? `?${params}` : ''}`)
    .then((axiosResponse) => {
      const response = axiosResponse?.data;
      const currentPage = Number(axiosResponse.headers['content-range'].split('-')[0]);
      const totalItems = Number(axiosResponse.headers['content-range'].split('/')[1]);
      const data = { data: response.data, currentPage, totalItems };

      dispatch({
        type: FETCH_SETTLEMENT_REPORT_SUCCESS, payload: data
      });
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
      }
      dispatch({ type: FETCH_SETTLEMENT_REPORT_ERROR });
      console.error(error);
    });
};

export const deleteSettlementReport = (id) => (dispatch) => {
  dispatch({ type: DELETE_SETTLEMENT_REPORT_INIT });
  dataAxios.delete(`settlementReports/${id}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: DELETE_SETTLEMENT_REPORT_SUCCESS, payload: { id } });
    dispatch({ type: SHOW_MESSAGE, payload: response.message });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    } else {
      const message = 'Error while deleting report';
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: message });
    }
    dispatch({ type: DELETE_SETTLEMENT_REPORT_ERROR });
    console.error(error);
  });
};

export const updateSettlementReport = (id, values) => (dispatch) => {
  dispatch({ type: UPDATE_SETTLEMENT_REPORT_INIT });
  dataAxios.put(`settlementReports/${id}`, values).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;

    dispatch({ type: UPDATE_SETTLEMENT_REPORT_SUCCESS, payload: data });
    dispatch({ type: SHOW_MESSAGE, payload: 'Updated' });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: UPDATE_SETTLEMENT_REPORT_ERROR });
    console.error(error);
  });
};

export const markSettlementReportsAsSettled = (values) => (dispatch) => {
  dispatch({ type: UPDATE_SETTLEMENT_REPORT_INIT });
  dataAxios.put('settlementReports/multiUpdate/markAsSettled', values).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;

    dispatch({ type: UPDATE_SETTLEMENT_REPORT_SUCCESS, payload: data });
    dispatch({ type: SHOW_MESSAGE, payload: 'Updated' });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: UPDATE_SETTLEMENT_REPORT_ERROR });
    console.error(error);
  });
};

export const sendSettlementReportSummary = (values) => (dispatch) => {
  dispatch({ type: UPDATE_SETTLEMENT_REPORT_INIT });
  unicornAxios.post('settlement-reports/send-report-summary', values).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;

    dispatch({ type: UPDATE_SETTLEMENT_REPORT_SUCCESS, payload: data });
    dispatch({ type: SHOW_MESSAGE, payload: 'Done!' });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: UPDATE_SETTLEMENT_REPORT_ERROR });
    console.error(error);
  });
};

export const setActiveMerchantAccount = (merchantId) => (dispatch) => {
  sessionStorage.setItem('activeMerchant', merchantId);
  dispatch({ type: SET_ACTIVE_MERCHANT_ACCOUNT, payload: merchantId });
};

export const generateAPIKey = (merchantData) => (dispatch) => {
  dispatch({ type: GENERATE_API_KEY_INIT });
  dataAxios.post('merchantDtls/', merchantData).then(({ data }) => {
    dispatch({ type: GENERATE_API_KEY_SUCCESS, payload: data.data });
    dispatch({ type: SHOW_MESSAGE, payload: 'Successfully created API Token' });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: GENERATE_API_KEY_ERROR });
  });
};

export const updateAPIKey = (id, merchantData) => (dispatch) => {
  dispatch({ type: UPDATE_API_KEY_INIT });
  dataAxios.put(`merchantDtls/${id}`, merchantData).then(({ data }) => {
    dispatch({ type: UPDATE_API_KEY_SUCCESS, payload: data.data });
    dispatch({ type: SHOW_MESSAGE, payload: 'Successfully updated API Token' });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: UPDATE_API_KEY_ERROR });
  });
};

export const deleteAPIKey = (merchantId, id) => (dispatch) => {
  dispatch({ type: DELETE_API_KEY_INIT });
  dataAxios.delete(`merchantDtls/${merchantId}/${id}`).then(() => {
    dispatch({ type: DELETE_API_KEY_SUCCESS, payload: id });
    dispatch({ type: SHOW_MESSAGE, payload: 'Successfully deleted API Token' });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: DELETE_API_KEY_ERROR });
  });
};

export const getAPIKeys = (merchantId) => (dispatch) => {
  dispatch({ type: FETCH_API_KEYS_INIT });
  dataAxios.get(`merchantDtls/merchant/${merchantId}`).then(({ data }) => {
    dispatch({ type: FETCH_API_KEYS_SUCCESS, payload: data.data });
  }).catch((error) => {
    if (error.response && error.response.data) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: error.response.data.message });
    }
    dispatch({ type: FETCH_API_KEYS_ERROR });
  });
};

export const getTrafficWebsites = (params) => (dispatch) => {
  dispatch({ type: FETCH_TRAFFIC_WEBSITES_START });
  dataAxios.get(`traffic-websites${params ? `?${params}` : ''}`).then(({ data, headers }) => {
    dispatch({
      type: FETCH_TRAFFIC_WEBSITES_SUCCESS,
      payload: data.data,
      meta: {
        page: Number(headers['content-range'].split('-')[0]),
        pageTotal: Number(headers['content-range'].split('/')[1]),
      },
    });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_TRAFFIC_WEBSITES_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const addTrafficWebsite = (fdsCard) => (dispatch) => {
  dispatch({ type: ADD_TRAFFIC_WEBSITE_START });
  dataAxios.post('traffic-websites', fdsCard).then((axiosResponse) => {
    const response = axiosResponse?.data;
    if (response.data && response.data.name !== 'MongoError') {
      dispatch({ type: ADD_TRAFFIC_WEBSITE_SUCCESS, payload: response.data });
      dispatch({ type: SHOW_MESSAGE, payload: `Added traffic website: ${response.data.name}` });
    } else {
      dispatch({ type: ADD_TRAFFIC_WEBSITE_ERROR, payload: response.data.name });
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble adding this" });
      console.error('Error: ', response.data.name);
    }
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: ADD_TRAFFIC_WEBSITE_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const updateTrafficWebsite = (fdsCardId, values) => (dispatch) => {
  dispatch({ type: UPDATE_TRAFFIC_WEBSITE_START });
  dataAxios.put(`traffic-websites/${fdsCardId}`, values).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: UPDATE_TRAFFIC_WEBSITE_SUCCESS, payload: response.data });
    dispatch({ type: SHOW_MESSAGE, payload: 'Succesfully updated fds card' });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble updating this" });
    }
    dispatch({ type: UPDATE_TRAFFIC_WEBSITE_ERROR });
    console.error('Error: ', error.message);
  });
};
